<template>
  <div class="input-field">
    <template v-if="showHeader">
      <div class="flex items-center justify-between mb-2">
        <label class="typo__label text-sm font-medium text-gray-900 !mb-0">
          {{ framework.name }}
        </label>

        <button
          type="button"
          class="flex items-center text-secondary underline underline-offset-2"
          @click="$emit('show-framework-overview', framework)"
        >
          <i class="fa-solid fa-circle-question text-lg" />
          <span class="pl-1.5 text-sm">Framework Overview</span>
        </button>
      </div>
    </template>

    <Multiselect
      v-model="model"
      class="framework-category-select-multiselect"
      label="title"
      :options="framework.categories"
      :show-labels="false"
      track-by="id"
      multiple
      :limit="2"
      :limit-text="count => `+ ${count} more`"
      :close-on-select="false"
      :placeholder="placeholder"
      :searchable="false"
    >
      <template #tag="{ option, remove }">
        <span
          class="flex items-center border rounded-full px-1.5 py-1 whitespace-nowrap"
          :style="{ backgroundColor: getBackgroundColorIfCategorySelected(option.backgroundColor, option.id), borderColor: option.backgroundColor }"
        >
          <CategoryIcon
            :name="option.shortName"
            :background-color="option.backgroundColor"
            :icon="option.icon"
            class="[&_img]:!w-5 [&_img]:!h-5 [&_img]:rounded-full"
          />

          <span>
            <span
              class="mx-1 text-xs"
              :style="`color: ${option.backgroundColor}`"
            >
              {{ option.shortName }}
            </span>
          </span>

          <span
            :style="{ color: option.backgroundColor }"
            @click.stop.prevent="remove(option)"
          >
            &times;
          </span>
        </span>
      </template>

      <template #option="{ option: { id, icon, backgroundColor, shortName } }">
        <div
          class="flex items-center w-full p-3"
          :style="{ backgroundColor: getBackgroundColorIfCategorySelected(backgroundColor, id) }"
        >
          <CategoryIcon
            :name="shortName"
            :background-color="backgroundColor"
            :icon="icon"
            class="[&_img]:!w-8 [&_img]:!h-8"
          />

          <span
            class="font-semibold ml-2 leading-none"
            :style="`color: ${backgroundColor}`"
          >
            {{ shortName }}
          </span>
        </div>
      </template>
    </Multiselect>
  </div>
</template>

<script setup>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import { CategoryIcon } from '@/components/category';

defineEmits(['show-framework-overview']);

const props = defineProps({
  framework: {
    type: Object,
    default: () => ({}),
  },
  showHeader: {
    type: Boolean,
    default: () => true,
  },
  placeholder: {
    type: String,
    default: 'Select an option',
  },
});

const model = defineModel({ type: Array, default: () => ([]) } );

const getBackgroundColorIfCategorySelected = (backgroundColor, categoryId) => {
  // An array is returned for model on the Mindmap view but a single object is returned for the Table view
  if (model.value?.length) {
    return model.value.find(category => category.framework.id === props.framework.id && category.id === categoryId) ? `${backgroundColor}20` : '';
  } else {
    return (model.value?.framework?.id === props.framework?.id && categoryId === model.value?.id ) ? `${backgroundColor}20` : '';
  }
};

</script>

<!--all this nesting is necessary for priority-->
<style>
.multiselect.framework-category-select-multiselect {
  .multiselect__select {
    @apply top-1;
  }

  .multiselect__content-wrapper {
    .multiselect__content {
      @apply max-h-[225px];

      .multiselect__element {
        .multiselect__option {
          @apply p-0;
        }
      }
    }
  }
}
</style>
